
export const RateTypeNames = {
  YEAR: '综合年化',
  MONTH: '月',
  DAY: '日',
};

// 针对利率展示精度进行控制
export const getShowRateValue = (rateValue: number): string => (rateValue * 100).toFixed(3).replace(/(\.?[0]+)$/g, '');
